__turbopack_context__.v({
  "active": "MegaMenu-module__wqxxYW__active",
  "card": "MegaMenu-module__wqxxYW__card",
  "cardAlwaysLight": "MegaMenu-module__wqxxYW__cardAlwaysLight",
  "cardComingSoon": "MegaMenu-module__wqxxYW__cardComingSoon",
  "cardDesc": "MegaMenu-module__wqxxYW__cardDesc",
  "cardLight": "MegaMenu-module__wqxxYW__cardLight",
  "cardTitle": "MegaMenu-module__wqxxYW__cardTitle",
  "cityList": "MegaMenu-module__wqxxYW__cityList",
  "clip": "MegaMenu-module__wqxxYW__clip",
  "comingSoonBadge": "MegaMenu-module__wqxxYW__comingSoonBadge",
  "copy": "MegaMenu-module__wqxxYW__copy",
  "copyTop": "MegaMenu-module__wqxxYW__copyTop",
  "cta": "MegaMenu-module__wqxxYW__cta",
  "ctas": "MegaMenu-module__wqxxYW__ctas",
  "imageWrap": "MegaMenu-module__wqxxYW__imageWrap",
  "intro": "MegaMenu-module__wqxxYW__intro",
  "introLabel": "MegaMenu-module__wqxxYW__introLabel",
  "linkList": "MegaMenu-module__wqxxYW__linkList",
  "more": "MegaMenu-module__wqxxYW__more",
  "moreColumns": "MegaMenu-module__wqxxYW__moreColumns",
  "moreGroup": "MegaMenu-module__wqxxYW__moreGroup",
  "moreHeading": "MegaMenu-module__wqxxYW__moreHeading",
  "moreLink": "MegaMenu-module__wqxxYW__moreLink",
  "morePrimary": "MegaMenu-module__wqxxYW__morePrimary",
  "morePrimaryButton": "MegaMenu-module__wqxxYW__morePrimaryButton",
  "open": "MegaMenu-module__wqxxYW__open",
  "outline": "MegaMenu-module__wqxxYW__outline",
  "panel": "MegaMenu-module__wqxxYW__panel",
  "scrolled": "MegaMenu-module__wqxxYW__scrolled",
  "showcase": "MegaMenu-module__wqxxYW__showcase",
  "solid": "MegaMenu-module__wqxxYW__solid",
  "stack": "MegaMenu-module__wqxxYW__stack",
  "surface": "MegaMenu-module__wqxxYW__surface",
  "tagline": "MegaMenu-module__wqxxYW__tagline",
  "text": "MegaMenu-module__wqxxYW__text",
  "wrap": "MegaMenu-module__wqxxYW__wrap",
});
